import { onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue'

export const useShowStickyBarTopSmall = () => {
  const showBar = ref(false)
  const lastYPosition = ref(0)

  function updateTopBarDisplay() {
    // If the screen is smaller than 768px, we don't want to show the sticky bar
    if (window.matchMedia('(min-width: 768px)').matches) {
      showBar.value = false

      return
    }

    // Saving the current scroll position here
    // to avoid layout thrashing
    // See https://gist.github.com/paulirish/5d52fb081b3570c81e3a/565c05680b27c9cfd9f5e971d295cd558c3e1843#window
    const currentScrollY = window.scrollY
    // To have the correct behavior we need to target the first component of the bottom of the page.
    // Reco are not mandatory so if the reco block is failing, we don't have our limit anymore.
    // Fallback would be reviews but we can have products without reviews.
    // Fallback would be the eco block but we have it only for smartphones.
    // Fallback would be SEO tech specs has it's on every page.
    const recoSection = document.querySelector('[data-id="reco-section"]')
    const reviewsSection = document.querySelector('#reviews')
    const seoTechSpecSection = document.querySelector(
      '[data-id="seo-technical-specs"]',
    )
    const bottomPageSection =
      recoSection || reviewsSection || seoTechSpecSection
    const bottomPageSectionTopScroll =
      bottomPageSection?.getBoundingClientRect().top

    // Show the Sticky bar when ATC is no more visible
    // Show the Sticky bar when scrolling down
    if (
      currentScrollY > 300 &&
      (lastYPosition.value < currentScrollY ||
        (bottomPageSectionTopScroll && bottomPageSectionTopScroll > 0))
    ) {
      showBar.value = true
    } else if (lastYPosition.value > currentScrollY) {
      showBar.value = false
    }
    lastYPosition.value = currentScrollY
  }

  function handleScroll() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      window.requestAnimationFrame(updateTopBarDisplay)
    }
  }

  // The component generally gets unmounted when changing product, but when we play with the pickers
  // we want to keep the bar displayed. Here we make sure to have the right display value when mounting the
  // component to avoid repeating the appearance animation of RevStickyBar
  onBeforeMount(() => {
    updateTopBarDisplay()
  })

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
  })

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll)
  })

  return {
    showBar,
    lastYPosition,
  }
}
